import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from "../../shared";
import { Observable } from "rxjs";
import { MembershipReportQueryCriteriaClass } from "../../../criteria";

@Injectable({ providedIn: "root" })
export class MembershipGenerateReportService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + "membership-reports";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + "membership-reports";
    this.httpClient = http;
  }

  generateMembershipReport(dtoObject: MembershipReportQueryCriteriaClass, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/generate-csv-report';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl,dtoObject,this.getHttpHeader(visa));
  }

  downloadReport(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/backoffice-ep/' + guid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }
}